/* eslint-disable */
export default {
  tollFree: '免费电话',
  rcvPmiMeetingTitle: '{extensionName} 的视频会议',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
